module.exports = __webpack_public_path__ + "img/Logo-gmx1.dc6791f9.png";